import React from 'react'
import { DraggableCard, DroppableCard } from 'components/library'

const QuestionForm = props => (
  <div className={`Question-form${props.disabled ? ' is-disabled' : ''}`}>
    {(() => {
      switch(props.type) {
        case 'single':
        case 'multiple':
          return <FormPick {...props} />

        case 'dragdrop':
          return <FormDragDrop {...props} />

        case 'component':
          return <props.component {...props} />

        default:
          return null
      }
    })()}
  </div>
)

class FormDragDrop extends React.Component {
  get dataList1() {
    return this.props.value ? this.props.value.filter(item => item.location === 1) : []
  }

  get dataList2() {
    return this.props.value ? this.props.value.filter(item => item.location === 2) : []
  }

  render() {
    return (
      <div>
        <div className="Draggable-cards">
          {this.props.answers.map((answer, idx) => (
            <DraggableCard
              key={idx}
              count
              data={{...answer, status: this.props.value && this.props.value.find(item => item.aId === answer.id) ? 1 : 0 }}
              onDrop={this.props.onPick} />
          ))}
        </div>

        <div className="Droppable-cards">
          <DroppableCard
            background={this.props.droppable[0].background}
            label={this.props.droppable[0].label}
            data={{ id: 1, qId: this.props.id }}
            list={this.dataList1} />

          <DroppableCard
            background={this.props.droppable[1].background}
            label={this.props.droppable[1].label}
            data={{ id: 2, qId: this.props.id }}
            list={this.dataList2} />
        </div>
      </div>
    )
  }
}

const FormPick = props => (
  <div>
    {props.component && <props.component/>}
    {props.answers.map((answer, idx) => (
      <Answer
        key={idx}
        {...answer}
        type={props.type}
        selected={props.value && props.value.indexOf((answer.id).toString()) > -1}
        onPick={e => props.onPick(e, props.id)} />
    ))}
  </div>
)

const Answer = props => (
  <div className={`Answer${props.selected ? ' is-selected' : ''}${props.type ? ' is-'+ props.type : ''}`}>
    <label>
      <span className="Answer-input"><AnswerInput {...props} /></span>
      <span className="Answer-label">{props.label}</span>
    </label>
  </div>
)

const InputRadio = props => (
  <div className="Input Input-radio">
    <input type="radio" name="answer" value={props.id} onChange={props.onPick} />
  </div>
)

const InputCheckbox = props => (
  <div className="Input Input-checkbox">
    <input type="checkbox" name="answer" value={props.id} onChange={props.onPick} />
  </div>
)

const answerTypes = {
  single: InputRadio,
  multiple: InputCheckbox
}

const AnswerInput = props => {
  const SpecificInput = answerTypes[props.type]
  return <SpecificInput {...props} />
}

export default QuestionForm



// WEBPACK FOOTER //
// ./src/components/views/endtest/components/QuestionForm.js